import React, { useState, useEffect, useMemo } from 'react';
import FlatDetails from './FlatDetails';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import PopUp from '../../../common/components/PopUp/PopUp';
import * as _ from 'lodash';
import { getApplicantionInfo } from '../../../common/utils/applicantionInfo';
import {
  getLeadProertyDetails,
  saveLeadPropertyDetails
} from '../../../common/constants/api';
import { customStyle } from './FlatDetails.module.css';
const masterData = {
  BuiltUpArae: {
    name: 'BuiltUpArae',
    legendname: 'Built Up Area',
    inputUnit: 'sq.ft',
    maxLength: 8,
    minLength: 0,
    rupeeIcon: false,
    showInText: false,
    customStyle: customStyle,
    type: 'number'
  },
  carpetArea: {
    name: 'carpetArea',
    legendname: 'Carpet Area',
    inputUnit: 'sq.ft',
    maxLength: 8,
    minLength: 0,
    rupeeIcon: false,
    showInText: false,
    customStyle: customStyle,
    type: 'number'
  },
  houseNO: {
    name: 'houseNO',
    legendname: 'House no',
    maxLength: 8,
    minLength: 0,
    rupeeIcon: false,
    showInText: false,
    customStyle: customStyle,
    type: 'text'
  },
  flatNo: {
    name: 'FaltNo',
    legendname: 'Flat No',
    maxLength: 8,
    minLength: 0,
    rupeeIcon: false,
    showInText: false,
    customStyle: customStyle,
    type: 'text'
  },
  plotNo: {
    name: 'plotNo',
    legendname: 'Plot No',
    maxLength: 8,
    minLength: 0,
    rupeeIcon: false,
    showInText: false,
    customStyle: customStyle,
    type: 'text'
  },

  blockNo: {
    name: 'blockNo',
    legendname: 'Block No',
    maxLength: 8,
    minLength: 0,
    rupeeIcon: false,
    showInText: false,
    customStyle: customStyle,
    type: 'text'
  },
  selectFloor: {
    name: 'selectFloor',
    legendname: 'Floor No',
    maxLength: 3,
    minLength: 0,
    customStyle: customStyle,
    type: 'number',
    rupeeIcon: false,
    showInText: false
  },
  plc: {
    name: 'plc',
    legendname: 'PLC',
    maxLength: 10,
    minLength: 0,
    rupeeIcon: true,
    showInText: false,
    customStyle: customStyle,
    type: 'number'
  },
  floorRise: {
    name: 'floorRise',
    legendname: 'Floor Rise',
    maxLength: 8,
    minLength: 0,
    rupeeIcon: true,
    showInText: false,
    customStyle: customStyle,
    type: 'number'
  },
  plotArea: {
    name: 'plotArea',
    legendname: 'Plot Area',
    inputUnit: 'sq.ft',
    maxLength: 8,
    minLength: 0,
    rupeeIcon: false,
    showInText: false,
    customStyle: customStyle,
    type: 'number'
  },
  marketvalue: {
    name: 'marketValue',
    legendname: 'Market value',
    maxLength: 13,
    minLength: 0,
    rupeeIcon: true,
    showInText: false,
    customStyle: customStyle,
    type: 'number'
  }
};

const FlatDetailsJson = ({ value, seStep }) => {
  const [getData, setData] = useState([]);
  const [popUpText, setPopUpText] = useState('');
  const [popUpType, setPopUpType] = useState('loading');
  const [show, setShow] = useState(false);
  const [leadId, setLeadId] = useState(getApplicantionInfo().leadId);
  const [applicantId, setApplicantId] = useState(
    getApplicantionInfo().leadApplicantId
  );
  const [formValues, setFormValues] = useState(value.formValues());
  const [hideSubmit, setHideSubmit] = useState(false);
  const [propertyType, setPropertyType] = useState(value.selectedSubProperty());
  const [loanType, setLoanType] = useState(value.selectedProperty());

  useEffect(() => {
    //"Flat","Villa","Independent House"

    if (loanType == 'Renovation/Improvement') {
      if (propertyType == 'Villa') {
        setData([
          masterData['BuiltUpArae'],
          masterData['plotArea'],
          masterData['houseNO'],
          masterData['blockNo'],
          masterData['carpetArea'],
          masterData['marketvalue']
        ]);
      } else if (propertyType == 'Flat') {
        setData([
          masterData['BuiltUpArae'],
          masterData['blockNo'],
          masterData['carpetArea'],
          masterData['selectFloor'],
          masterData['houseNO'],
          masterData['marketvalue']
        ]);
      } else if (propertyType == 'Independent House') {
        setData([
          masterData['BuiltUpArae'],
          masterData['plotArea'],
          masterData['houseNO'],
          masterData['blockNo'],
          masterData['marketvalue']
        ]);
      }
    } else if (loanType == 'Self Construction') {
      setPropertyType('Plot');
      setData([
        masterData['BuiltUpArae'],
        masterData['plotArea'],
        masterData['houseNO'],
        masterData['blockNo'],
        masterData['marketvalue']
      ]);
    } else if (loanType == 'New Purchase' && propertyType == 'Flat') {
      setData([
        masterData['BuiltUpArae'],
        masterData['carpetArea'],
        masterData['houseNO'],
        masterData['blockNo'],
        masterData['selectFloor'],
        masterData['plc'],
        masterData['floorRise']
      ]);
    } else if (loanType == 'New Purchase' && propertyType == 'Villa') {
      setData([
        masterData['BuiltUpArae'],
        masterData['carpetArea'],
        masterData['plotArea'],
        masterData['houseNO'],
        masterData['blockNo'],
        masterData['plc']
      ]);
    } else if (
      loanType == 'New Purchase' &&
      propertyType == 'Independent House'
    ) {
      setData([
        masterData['BuiltUpArae'],
        masterData['plotArea'],
        masterData['houseNO'],
        masterData['blockNo']
      ]);
    } else if (loanType == 'New Purchase' && propertyType == 'Plot') {
      setData([masterData['plotArea'], masterData['houseNO']]);
    } else if (
      loanType == 'New Purchase' &&
      propertyType == 'Independent House'
    ) {
      setData([
        masterData['BuiltUpArae'],
        masterData['houseNO'],
        masterData['blockNo'],
        masterData['plc']
      ]);
    } else if (loanType == 'Plot+Construction') {
      setData([masterData['plotArea'], masterData['plotNo']]);
    } else if (loanType == 'Resale') {
      if (propertyType == 'Flat') {
        setData([
          masterData['BuiltUpArae'],
          masterData['carpetArea'],
          masterData['houseNO'],
          masterData['blockNo'],
          masterData['selectFloor'],
          masterData['plc'],
          masterData['floorRise']
        ]);
      } else if (propertyType == 'Villa') {
        setData([
          masterData['BuiltUpArae'],
          masterData['carpetArea'],
          masterData['houseNO'],
          masterData['blockNo'],
          masterData['plc']
        ]);
      } else if (propertyType == 'Independent House') {
        setData([
          masterData['BuiltUpArae'],
          masterData['plotArea'],
          masterData['houseNO'],
          masterData['blockNo']
        ]);
      } else if (propertyType == 'Plot') {
        setData([masterData['plotArea'], masterData['houseNO']]);
      }
    } else if (propertyType == 'Villa') {
      setData([masterData['plotArea'], masterData['houseNO']]);
    } else if (propertyType == 'Flat') {
      setData([
        masterData['BuiltUpArae'],
        masterData['carpetArea'],
        masterData['houseNO'],
        masterData['blockNo'],
        masterData['selectFloor']
      ]);
    } else if (propertyType == 'Independent House') {
      setData([
        masterData['BuiltUpArae'],
        masterData['plotNo'],
        masterData['blockNo']
      ]);
    } else if (propertyType == 'Plot') {
      setData([masterData['plotArea'], masterData['plotNo']]);
    }
  }, []);

  const Validate = Formikvalues => {
    const errors = {};
    getData.map(each => {
      if (
        !Formikvalues[each.name.toString()] ||
        Formikvalues[each.name.toString()] == ''
      )
        errors[each.name.toString()] = 'Required';
    });
    return errors;
  };
  return (
    <Formik
      initialValues={{
        BuiltUpArae: '',
        carpetArea: '',
        houseNO: '',
        blockNo: '',
        selectFloor: 0,
        plc: '',
        floorRise: '',
        loanSelectedData: localStorage.hasOwnProperty('LoanProductDetails')
          ? localStorage.getItem('LoanProductDetails')
          : false
      }}
      validate={Formikvalues => Validate(Formikvalues)}
      onSubmit={(values, { setSubmitting }) => {
        const getBody = () => {
          let submit_value = formValues;
          let body = {
            productId: _.get(submit_value, 'ChooseLoanPurpose.loneTypeID'),

            completionStatus: {
              percentageCompleted: !_.get(
                submit_value,
                'devStatus.completed',
                ''
              )
                ? _.get(submit_value, 'devStatus.devPercentage.value', 0)
                    .toString()
                    .split('-')[0]
                : 100
            },
            devDetails: {
              name: _.get(submit_value, 'devStatus.developerName', ''),
              projectName: _.get(submit_value, 'devStatus.projName', ''),
              reraNumber: _.get(submit_value, 'devStatus.reraNo', '')
            },
            dimensions: {
              builtUpArea: _.get(values, 'BuiltUpArae', ''),
              carpetArea: _.get(values, 'carpetArea', ''),
              plotNo: _.get(values, 'plotNo', ''),
              blockNo: _.get(values, 'blockNo', ''),
              floorNo: _.get(values, 'selectFloor', ''),
              flatNo: _.get(values, 'FaltNo', ''),
              houseNo: _.get(values, 'houseNO', ''),
              plotArea: _.get(values, 'plotArea', ''),
              plc: _.get(values, 'plc', ''),
              floorRise: _.get(values, 'floorRise', ''),
              marketValue: _.get(values, 'marketValue', '')
            }
          };
          if (_.get(submit_value, 'ChooseLoanPurpose.loneTypeID', false) != 5) {
            body['completionStatus']['underDevelopment'] = !_.get(
              submit_value,
              'devStatus.completed',
              ''
            );
          } else {
            body['completionStatus']['underDevelopment'] = false;
          }

          if (
            ![8, 7].includes(
              _.get(submit_value, 'ChooseLoanPurpose.loneTypeID', true)
            )
          ) {
            body['propertyType'] = _.get(
              submit_value,
              'ChooseLoanPurpose.typeOfProperty',
              ''
            );
          } else {
            body['propertyType'] = 'Plot';
          }
          if (_.get(submit_value, 'devStatus.underDev', false)) {
            body['completionStatus']['possessionDate'] = `${_.get(
              submit_value,
              'devStatus.prosDate.year.value',
              ''
            )}-${_.get(
              submit_value,
              'devStatus.prosDate.month.value',
              ''
            )}-${_.get(submit_value, 'devStatus.prosDate.date.value', '')}`;
          }
          return body;
        };
        const handleSaveForm = async () => {
          await setPopUpText(
            <p>
              Submitting the Data, <br />
              Please Wait...{' '}
            </p>
          );
          await setPopUpType('loading');
          setShow(true);
          let body = getBody();

          saveLeadPropertyDetails(leadId, body)
            .then(res => {
              if (res.error) {
                throw new Error(res);
              }
              setShow(false);
              seStep('PropertyDetailDone');
              setHideSubmit(true);
            })
            .catch(async err => {
              await setPopUpText(err?.response?.data?.message.toString());
              await setPopUpType('fail');
              setShow(true);
            });
        };

        handleSaveForm();
      }}
    >
      {({
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        setFieldValue,
        errors,
        values
      }) => {
        useEffect(() => {
          const getSavedData = async () => {
            await setPopUpText(
              <p>
                Loading <br />
              </p>
            );
            await setPopUpType('loading');
            setShow(true);

            getLeadProertyDetails(leadId)
              .then(async res => {
                if (res.error) {
                  throw new Error(res.error.data.message);
                }
                if (res.dimensions) {
                  setFieldValue('BuiltUpArae', res.dimensions.builtUpArea);
                  setFieldValue('carpetArea', res.dimensions.carpetArea);
                  setFieldValue('houseNO', res.dimensions.houseNo);
                  setFieldValue('FaltNo', res.dimensions.flatNo);
                  setFieldValue('plotNo', res.dimensions.plotNo);
                  setFieldValue('selectFloor', res.dimensions.floorNo);
                  setFieldValue('blockNo', res.dimensions.blockNo);
                  setFieldValue('plotArea', res.dimensions.plotArea);
                  setFieldValue('plc', res.dimensions.plc);
                  setFieldValue('floorRise', res.dimensions.floorRise);
                  setFieldValue('marketValue', res.dimensions.marketValue);
                }
                setShow(false);
              })
              .catch(async err => {
                await setPopUpText(
                  <p>
                    {err.toString()} <br />
                  </p>
                );
                await setPopUpType('fail');
                setShow(true);
              });
          };
          getSavedData();
        }, []);

        return (
          <Form onSubmit={handleSubmit}>
            <div className="w-full px-5">
              <div className="text-left font-bold font-roboto text-sm text-black-0 my-5 ">
                {propertyType} Details
              </div>
              <div className="w-full md:flex md:flex-wrap">
                <FlatDetails MapFields={getData} />
              </div>
              {!hideSubmit ? (
                <button
                  // onClick={handleSaveForm}
                  button="submit"
                  className="submitButton w-56  font-semibold"
                >
                  NEXT
                </button>
              ) : null}
              <PopUp
                type={popUpType}
                text={popUpText}
                setShow={setShow}
                show={show}
              />
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default FlatDetailsJson;
